import i18n, { InitOptions } from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { enUS } from "@/locales";


export const resources = {
    en: { ...enUS },
};

// reuturns a Promise that needs to be awaited

export const i18nInit = (config?: InitOptions) =>
    i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            fallbackLng: "en",
            debug: true,
            react: {
                useSuspense: false,
            },
            resources,
            interpolation: {
                escapeValue: false, // not needed for react as it escapes by default
            },
            ...config,
        });
